import React, { useContext, useState, useEffect } from 'react'
import CustomerContext from '../../Context/CustomerContext'
import useFetchGet from '../../Fetch/useFetchGet';
import HoursWorkedDetail from './HoursWorkedDetail'
import { buildGroupByDropdownOptions } from '../../SupplierReview/CustomComponents/GraphGridTools'

function HoursWorkedDetailLogic() {
    const {setCurrentPage} = useContext(CustomerContext);
    const {REACT_APP_API_URL} = process.env;
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState();
    const [gridApi, setGridApi] = useState();
    const [onlyActive, setOnlyActive] = useState(false);
    const [groupByOptions, setGroupByOptions] = useState();
    const [defaultColDef] = useState({
        resizable: true,
        sortable: true,
        filter: true,
        enableValue: true,
        enableRowGroup: true,
        enablePivot: true,
      });
      const FormatDate = (params) => { 
        if(params.value) return params.value.split('T')[0]
     }
    const [columnDefs] = useState([
    {headerName:'Customer',field:'CustomerName', chartDataType: 'category', rowGroup: true},
    {headerName:'Department',field:'DepartmentName', chartDataType: 'category'},
    {headerName:'Employee',field:'EmployeeName', chartDataType: 'category'},
    {field: 'EmployeeID', chartDataType: 'category', filter: 'agSetColumnFilter' },
    {field: 'AlternateID', chartDataType: 'category', filter: 'agSetColumnFilter' },
    {field: 'WeekendDate', valueFormatter: FormatDate},
    {field:'Shift', chartDataType: 'category'},
    {field:'Supervisor', chartDataType: 'category'},
    {field:'TotalHours',filter: 'agNumberColumnFilter', valueFormatter: (count)=>{return MakeDouble(count)}, cellClass: 'align-right', aggFunc: 'sum'},
    {field:'RegHours',filter: 'agNumberColumnFilter', valueFormatter: (count)=>{return MakeDouble(count)}, cellClass: 'align-right', aggFunc: 'sum'},
    {field:'OTHours',filter: 'agNumberColumnFilter', valueFormatter: (count)=>{return MakeDouble(count)}, cellClass: 'align-right', aggFunc: 'sum'},
    {field:'DTHours',filter: 'agNumberColumnFilter', valueFormatter: (count)=>{return MakeDouble(count)}, cellClass: 'align-right', aggFunc: 'sum'},
    ])
    const { data, loading } = useFetchGet(((startDate&&endDate)&&`${REACT_APP_API_URL}/Reports/GetHoursWorkedDetail`),{startDate:(startDate&&startDate.value.TheDate),endDate:(endDate&&endDate.value.TheDate),CurrentlyActive:onlyActive})
    const { data: sundays } = useFetchGet(`${REACT_APP_API_URL}/Reports/Getsundays`,{weeks:52})

    useEffect(()=>{
      if(sundays){
        setStartDate({value:sundays[0], label:sundays[0].DateValue})
        setEndDate({value:sundays[0], label:sundays[0].DateValue})
      }
    // eslint-disable-next-line
    },[sundays])


    const MakeDouble = (int) => { 
      if(int.value||int.value===0){
        return Number(int.value).toLocaleString(undefined, {minimumFractionDigits: 2})
      }else{
        return ''
      }
     }

    useEffect(()=>{
        if(data){
          setPinnedBottomRowData([{
            TotalHours: `${Reduce(data, 'TotalHours')}`,
            RegHours: `${Reduce(data, 'RegHours')}`,
            OTHours: `${Reduce(data, 'OTHours')}`,
            DTHours: `${Reduce(data, 'DTHours')}`,
          }])
        }
    // eslint-disable-next-line
    },[data])

    useEffect(()=>{
      setCurrentPage('Hours Worked Detail')
    },[setCurrentPage])

    const HandleGroupByDropdownChange = (e, gridApi) => { 
      // get all the column defs
      // find the one that matches the dropdown
      // add the row group attribute
      // remove it from all others
      // setColumnDefs to the updated column defs
      let columnDefs = gridApi.getColumnDefs();
      columnDefs.forEach(column=>{
        if(column.field===e.label||column.headerName===e.label){
          column.rowGroup = true;
          column.sort = 'desc';
        }else{
          column.rowGroup = false;
          column.sort = null;
        }
      })
      gridApi.setColumnDefs(columnDefs)
    }

    const Reduce = (data, dataName) => { 
       let total = data.reduce((last,current)=>last+current[dataName],0).toFixed(2)
       return total
     }

    const onGridReady = (params) => { 
        setGridApi(params.api)
    }

    const onFilterChanged = (e) => { 
        let data = [];
        gridApi.forEachNodeAfterFilter(node=>{
           data.push(node.data);
        })
        setPinnedBottomRowData([{
          TotalHours: `${Reduce(data, 'TotalHours')}`,
          RegHours: `${Reduce(data, 'RegHours')}`,
          OTHours: `${Reduce(data, 'OTHours')}`,
          DTHours: `${Reduce(data, 'DTHours')}`,
        }])
    }

    const onBtnExport = () => {
      gridApi.exportDataAsCsv();
  };

  const onFirstDataRendered = (params) => {
    setGroupByOptions(buildGroupByDropdownOptions(params))
    setGridApi(params.api)
  }

  return (
    <HoursWorkedDetail
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        data={data}
        onGridReady={onGridReady}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        pinnedBottomRowData={pinnedBottomRowData}
        onFilterChanged={onFilterChanged}
        startDate={startDate}
        endDate={endDate}
        sundays={sundays}
        onBtnExport={onBtnExport}
        onlyActive={onlyActive}
        setOnlyActive={setOnlyActive}
        loading={loading}
        onFirstDataRendered={onFirstDataRendered}
        groupByOptions={groupByOptions}
        gridApi={gridApi}
        HandleGroupByDropdownChange={HandleGroupByDropdownChange}
    ></HoursWorkedDetail>
  )
}

export default HoursWorkedDetailLogic